import { colorPalette } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const ListInfo = styled.ul`
  padding-right: 1em;
  padding-left: 3em;
  li {
    color: #f57e44;
  }
`;

export const EmailListContainer = styled.div`
  width: 100%;
  & .Mui-error {
    font-size: 12px;
    line-height: normal;
    font-weight: 300;
    border-color: ${colorPalette.red45};
  }
`;
